// Proper typographic marks at render time: curly quotes, true dashes, ellipses.
const OPEN = /(^|[\s(\[{<\u2014\u2013-])"/g;
const OPEN_SINGLE = /(^|[\s(\[{<\u2014\u2013-])'/g;

export function smarten(text) {
  if (typeof text !== "string") return text;
  return text
    .replace(OPEN, "$1\u201C")
    .replace(/"/g, "\u201D")
    .replace(OPEN_SINGLE, "$1\u2018")
    .replace(/'/g, "\u2019")
    .replace(/\.\.\./g, "\u2026")
    .replace(/(\S)--(\S)/g, "$1\u2014$2")
    .replace(/ -- | - /g, " \u2014 ");
}
